'use client'
import { Typography } from 'components/Contentful'

export const BorderTextBox = ({ content, variant, id }) => {
  return (
    <div className={'border border-neutral-300 p-4 border-solid'} id={id}>
      <Typography content={content} variant={variant ? variant : 'bodyXs'} fontWeight="regular" />
    </div>
  )
}
